import React from 'react';
import { Route } from 'react-router';
import EgiftCardContainer from 'split-chunk-loader?lazy!../EgiftCard/EgiftCardContainer';
import { lazify } from '../Common/Helper';

const metadata = {
    title: 'eGift Cards - Create Personalised Gift Cards Online',
    metaDescription: `Celebrate special occasions with personalised e-gift cards from {storeName} - the perfect way to send instant joy to loved ones.`,
};

const EGiftCardRoute = (
    <Route label="Gift Card" helmet={metadata} path="egift-card" component={lazify(EgiftCardContainer)} />
);

export default EGiftCardRoute;


// WEBPACK FOOTER //
// ./src/Routes/EGiftCardRoute.js